import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { paymentsAPI } from '../lib/api';

const LOW_CREDIT_THRESHOLD = 20;

// Shows a dismissible banner when the account's available credits run low.
export default function LowCreditBanner() {
  const navigate = useNavigate();
  const [credits, setCredits] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    paymentsAPI.getSubscription()
      .then((res) => setCredits(res.data.credits))
      .catch(() => {});
  }, []);

  if (dismissed || !credits) return null;
  const available = credits.total_available ?? 0;
  // Only nudge accounts that actually have a plan/credits configured.
  if (available >= LOW_CREDIT_THRESHOLD) return null;

  const isOut = available <= 0;

  return (
    <div
      data-testid="low-credit-banner"
      style={{
        display: 'flex', alignItems: 'center', gap: '0.875rem',
        background: isOut ? '#FEF2F2' : '#FFFBEB',
        border: `1px solid ${isOut ? '#FECACA' : '#FDE68A'}`,
        borderRadius: 10, padding: '0.875rem 1.125rem', marginBottom: '1.25rem',
      }}
    >
      <span style={{
        width: 30, height: 30, borderRadius: '50%', flexShrink: 0,
        background: isOut ? '#FEE2E2' : '#FEF3C7',
        color: isOut ? '#DC2626' : '#B45309',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '0.875rem', fontWeight: 700, color: isOut ? '#991B1B' : '#92400E' }}>
          {isOut ? 'You are out of interview credits' : `Low on credits — ${available} remaining`}
        </div>
        <div style={{ fontSize: '0.75rem', color: isOut ? '#B91C1C' : '#B45309' }}>
          {isOut
            ? 'New AI interviews may be interrupted. Top up to keep hiring without delays.'
            : 'Top up now so AI interviews keep running smoothly. 100 credits for $20.'}
        </div>
      </div>
      <button
        data-testid="low-credit-buy-btn"
        onClick={() => navigate('/billing')}
        style={{ background: '#0076A3', color: '#fff', border: 'none', borderRadius: 8, padding: '0.5rem 1rem', fontSize: '0.8125rem', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
      >
        Buy Credits
      </button>
      <button
        data-testid="low-credit-dismiss-btn"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: '1.125rem', lineHeight: 1, padding: '0 0.25rem' }}
      >
        ×
      </button>
    </div>
  );
}
